<template>
  <ElButton type="default" :size="size"  @click="handleClick" v-outFocus>
    <IconHc type="qiehuan" size="14px"></IconHc>
    {{label}}
  </ElButton>
</template>

<script>
export default {
  name: 'HcToggleButton',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    openValue: {
      type: Number,
      default: 1,
    },
    openLabel: {
      type: String,
      default: '明细'
    },
    closeValue: {
      type: Number,
      default: 0,
    },
    closeLabel: {
      type: String,
      default: '总览'
    },
    size: {
      type: String,
      default: ''
    },
  },
  computed: {
    valueInner: {
      get() {
        return this.value || 0
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    label() {
      return this.valueInner ? this.openLabel : this.closeLabel
    }
  },
  methods: {
    handleClick() {
      this.valueInner = this.valueInner === this.openValue ? this.closeValue : this.openValue
    }
  },
}
</script>
